const initNewsFullSections = () => {
    [...document.querySelectorAll('.news-full-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initNewsFullSection(item));
};

const initNewsFullSection = (section) => {
    section.dataset.init = true;

    const navItems = section.querySelectorAll('.news-navigation li');
    const posts = section.querySelectorAll('.news-list .post');

    navItems.forEach(li => {
        li.addEventListener('click', () => {
            // Active class
            navItems.forEach(i => i.classList.remove('active'));
            li.classList.add('active');

            const slug = li.dataset.slug;

            posts.forEach(post => {
                const postSlug = post.dataset.slug;

                if (slug === 'all' || slug === postSlug) {
                    post.style.display = '';
                } else {
                    post.style.display = 'none';
                }
            });
        });
    });
};

export { initNewsFullSections };
